import styles from "./index.module.css";

export const Checkbox = (props) => {
  return (
    <div className={styles.wrapper}>
      <label className={styles.switch}>
        <input
          id={props.id}
          type="checkbox"
          checked={props.checked}
          onChange={() => {
            props.onChange();
          }}
        />
        <span className={styles.slider} />
      </label>
      <div className={styles.labelWrapper}>{props.label}</div>
    </div>
  );
};
